import React, { useState, createContext, useContext } from 'react';

const AuthContext = createContext(null);

const API_BASE = 'https://blog.rauth.cc/api';

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem('cms_token'));

  const login = async (password) => {
    const res = await fetch(`${API_BASE}/auth.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ password }),
    });
    const data = await res.json();
    if (res.ok && data.token) {
      localStorage.setItem('cms_token', data.token);
      setToken(data.token);
      return { ok: true };
    }
    return { ok: false, error: data.error || 'Anmeldung fehlgeschlagen.' };
  };

  const logout = () => {
    localStorage.removeItem('cms_token');
    setToken(null);
  };

  return (
    <AuthContext.Provider value={{ token, login, logout, isLoggedIn: !!token }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
